import { render, staticRenderFns } from "./PurpleInfoPanel.vue?vue&type=template&id=954192b2&scoped=true"
import script from "./PurpleInfoPanel.vue?vue&type=script&lang=js"
export * from "./PurpleInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./PurpleInfoPanel.vue?vue&type=style&index=0&id=954192b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954192b2",
  null
  
)

export default component.exports